<template>
    <form-card>
        <form class="ai-login-form" @submit.prevent="onSubmit">
            <dx-form :form-data="formData" :disabled="loading">
                <dx-simple-item
                    data-field="login"
                    editor-type="dxTextBox"
                    :editor-options="{ stylingMode: 'filled', placeholder: 'Логин' }"
                >
                    <dx-required-rule message="Поле должно быть заполнено" />
                    <dx-label :visible="false" />
                </dx-simple-item>

                <dx-simple-item>
                    <dx-button
                        id="ai-login-form-submit-button"
                        height="50"
                        width="100%"
                        type="default"
                        :use-submit-behavior="true"
                        @click="restoreAccess"
                    >
                        <div>
                            <span class="dx-button-text">
                                <dx-load-indicator v-if="loading" width="24px" height="24px" :visible="true" />
                                <span id="ai-login-form-submit-button-text" v-if="!loading"> Восстановить доступ </span>
                            </span>
                        </div>
                    </dx-button>
                    <div class="ai-login-form__return-link">
                        <router-link to="/infoenergo/login"> Вернуться к авторизации </router-link>
                    </div>
                </dx-simple-item>
            </dx-form>
        </form>
    </form-card>
</template>

<script setup>
import DxLoadIndicator from 'devextreme-vue/load-indicator';
import DxForm, { DxSimpleItem, DxRequiredRule, DxLabel } from 'devextreme-vue/form';
import { DxButton } from 'devextreme-vue';
import { dxUiAlert, dxUiNotify } from '@/utils/dx-helper';

import { reactive, ref } from 'vue';
import { getRestoreLinkCommon } from '@/service/admin-service';
import FormCard from '../../../src/layouts/auth-layout/components/form-card.vue';

const formData = reactive({
    login: '',
});
const loading = ref(false);

const restoreAccess = async () => {
    const responseGetRestoreLink = await getRestoreLinkCommon(formData.login, `${window.location.origin}`);

    if (responseGetRestoreLink?.result && responseGetRestoreLink.success) {
        dxUiAlert({
            showTitle: false,
            showCloseButton: true,
            message: 'На вашу почту отправлена ссылка на форму смены пароля',
        });
    } else {
        dxUiNotify(`${responseGetRestoreLink.errors[0]?.message}`, 'error');
    }
};

// async function onSubmit() {
//     loading.value = true;
//     // const {login} = formData;

//     // action

//     // if (!result.isOk) {
//     //   loading.value = false;
//     //   notify(result.message, "error", 2000);
//     // } else {
//     //   window.location.href = `http://localhost:${process.env.VUE_APP_PORT}/infoenergo`;
//     // }
// }
</script>

<style lang="scss" scoped>
.ai-login-form :first-child :first-child :first-child :first-child {
    padding-bottom: 35px;
    :is(.dx-item, .dx-box-item) :first-child :first-child {
        padding-bottom: 2px;
        :is(.dx-field-item-content, .dx-field-item-content-location-bottom):has(
                > :first-child :is(.dx-texteditor-container)
            ) {
            padding: 5px 5px;
            background-color: #fff;
            border-radius: 8px;
            border: 1px solid #03142533;
            :first-child {
                background-color: #fff;
                :first-child {
                    :first-child {
                        font-family: Golos, GolosText, sans-serif;
                        font-size: 16px;
                        :is(.dx-placeholder) {
                            font-family: Golos, GolosText, sans-serif;
                            font-size: 16px;
                        }
                    }
                }
            }
        }
    }
}
.ai-login-form {
    display: flex;
    flex-direction: column;
    gap: 1px;
    width: 380px;
    &__return-link {
        text-align: center;
        font-size: 1rem; /* 12px */
        line-height: 1rem; /* 16px */
        margin-top: 12px;
        :first-child {
            color: #03142580;
        }
    }
    &__return-link:hover {
        text-align: center;
        font-size: 1rem; /* 12px */
        line-height: 1rem; /* 16px */
        margin-top: 12px;
        :first-child {
            color: #6698cc;
        }
    }
}
#ai-login-form-submit-button {
    border-radius: 8px;
    font-size: 14px;
    margin-top: 11px;
}
#ai-login-form-submit-button-text {
    text-transform: none;
}
</style>
